// export const PROTOKOL_CONTRACT = "0x245203f6327F5dA8bBf92a1B09E7949b042E2485";

export const PROTOKOL_CONTRACT_ADDRESS =
  "0xe729596a52AcB129be37a6feAc6269c6783c3B59";
